import { localePath } from '../routes/publicPaths';

export const PROGRAM_TITLES = {
  imaar: 'إعمار',
  ramadan: 'مائدة الرحمن',
  saqya: 'سقيا',
  kafala: 'كفالة',
  adahi: 'أضحية العيد',
  ihyaa: 'أضحية العيد',
  namaa: 'نـماء',
  ighatha: 'إغاثة',
  omra: 'ضيوف الرحمن',
  caravane: 'قوافل تضامنية',
};

/** Rubriques sous-menu programme (style Ataa) — fallback si non défini en base */
export const getProgramSubNavItems = (slug, title) => {
  const programTitle = title || PROGRAM_TITLES[slug] || slug;

  if (slug === 'kafala') {
    return [
      { id: 'about', label: 'عن المشروع', icon: 'question' },
      { id: 'waiting', label: 'أيتام ينتظرون الكفالة', icon: 'sponsor' },
      { id: 'request', label: 'كفالة عامة', icon: 'files' },
      { id: 'donate', label: 'تبرع للمشروع', icon: 'coins' },
    ];
  }

  if (slug === 'saqya') {
    return [
      { id: 'about', label: 'تعرف على سقيا', icon: 'water' },
      { id: 'well-request', label: 'سقيا عامة', icon: 'water' },
      { id: 'current', label: 'المشاريع الحالية', icon: 'current' },
      { id: 'completed', label: 'المشاريع المنجزة', icon: 'completed' },
      { id: 'donate', label: 'تبرع للمشروع', icon: 'coins' },
    ];
  }

  if (slug === 'imaar') {
    return [
      { id: 'about', label: 'ما هو مشروع إعمار؟', icon: 'question' },
      { id: 'current', label: 'المشاريع الحالية', icon: 'current' },
      { id: 'completed', label: 'المشاريع المنجزة', icon: 'completed' },
      { id: 'donate', label: 'تبرع للمشروع', icon: 'coins' },
    ];
  }

  if (slug === 'ramadan') {
    return [
      { id: 'about', label: 'ما هي مائدة الرحمن؟', icon: 'question' },
      { id: 'current', label: 'المشاريع الحالية', icon: 'current' },
      { id: 'completed', label: 'المشاريع المنجزة', icon: 'completed' },
      { id: 'donate', label: 'تبرع للمشروع', icon: 'coins' },
    ];
  }

  if (slug === 'ramadan') {
    return [
      { id: 'about', label: 'ما هي مائدة الرحمن؟', icon: 'question' },
      { id: 'current', label: 'المشاريع الحالية', icon: 'current' },
      { id: 'completed', label: 'المشاريع المنجزة', icon: 'completed' },
      { id: 'donate', label: 'تبرع للمشروع', icon: 'coins' },
    ];
  }

  if (slug === 'omra') {
    return [
      { id: 'about', label: 'عن برنامج ضيوف الرحمن', icon: 'question' },
      { id: 'omra-request', label: 'طلب المساهمة في أداء مناسك العمرة', icon: 'files' },
      { id: 'current', label: 'رحلات العمرة الحالية', icon: 'current' },
      { id: 'completed', label: 'الرحلات المنجزة', icon: 'completed' },
      { id: 'donate', label: 'تبرع للمشروع', icon: 'coins' },
    ];
  }

  return [
    { id: 'about', label: `ما هو مشروع ${programTitle}؟`, icon: 'question' },
    { id: 'current', label: 'المشاريع الحالية', icon: 'current' },
    { id: 'completed', label: 'المشاريع المنجزة', icon: 'completed' },
    { id: 'donate', label: 'تبرع للمشروع', icon: 'coins' },
  ];
};

export const resolveProgramSubNavItems = (program) => {
  if (Array.isArray(program?.sub_nav_items) && program.sub_nav_items.length > 0) {
    return program.sub_nav_items;
  }
  return getProgramSubNavItems(program?.slug, program?.title);
};

export const resolveProgramSubNavPath = (slug, item, locale) => {
  if (item.path) return localePath(item.path, locale);
  return `${localePath(`/programmes/${slug}`, locale)}#${item.id}`;
};

export const PROGRAM_CATEGORY_MAP = {
  adahi: 'أضحية العيد',
  ihyaa: 'أضحية العيد',
  namaa: 'نـماء',
  kafala: 'كفالة',
  saqya: 'سقيا',
  ighatha: 'إغاثة',
  imaar: 'إعمار',
  ramadan: 'مائدة الرحمن',
  omra: 'ضيوف الرحمن',
  caravane: 'قوافل تضامنية',
};
